module.exports = __webpack_public_path__ + "img/faqBg.2450a600.webp";